export const DDMMYYYY = (date) => {
    if(date === "" || date === null || date === undefined) return ""
    let _date = date.split('T')[0].split('-');

    let _time = date.split('T')[1].split(':');

    return  `${_date[2]}/${_date[1]}/${_date[0]}  ${_time[0]}:${_time[1]}`
}

export const getStatus = (status) => {
    switch (status) {
        case null:
            
           return "Sin publicar"
            case false:
            
            return "Sin publicar"
                case true:
            
                return "Publicado"

        default:
            break;
    }
}